module.exports = "pegasus_template/assets/blocks/column-11-theme6.png";